import * as React from "react"
import { Box, FormControl, InputLabel, MenuItem, Select } from "@mui/material"
import Grid from '@mui/material/Grid2';
import { useTrackedDarkMode } from "../UserState";
import TimeInStoreOpen from "./Metrics/TimeInStoreOpen";
import TimeInStoreClosed from "./Metrics/TimeInStoreClosed";
import TechnicianTimeWorked from "./Metrics/TechnicianTimeWorked";
import Income from "./Metrics/Income";
import ServiceOrdersClosed from "./Metrics/ServiceOrdersClosed";
import ServiceOrdersCreated from "./Metrics/ServiceOrdersCreated";
import ServiceOrdersStale from "./Metrics/ServiceOrdersStale";
import ServicePartsStale from "./Metrics/ServicePartsStale";
import { MetricContainer } from "./Metrics/MetricComponents";
import OutstandingInvioces from "./Metrics/OutstandingInvoices";
import OutstandingInvioceBalances from "./Metrics/OutstandingInvoiceBalances";

export default function Metrics({ selectedLocations }) {
    const [darkMode,] = useTrackedDarkMode();
    const [daysBack, setDaysBack] = React.useState(30) // Default to 30 days
    const borderColor = darkMode ? '#FFF' : 'rgba(0, 0, 0, 0.87)'
    const metric_list = [
        { component: Income },
        { component: OutstandingInvioces },
        { component: OutstandingInvioceBalances },
        { component: ServiceOrdersCreated },
        { component: ServiceOrdersClosed },
        { component: TimeInStoreOpen },
        { component: TimeInStoreClosed },
        { component: TechnicianTimeWorked },
        { component: ServiceOrdersStale },
        { component: ServicePartsStale }
    ]

    return (
        <Box sx={{
            width: '100%',
            height: '100%'
        }}>
            <FormControl>
                <InputLabel id="metrics-days-back">Days Back</InputLabel>
                <Select
                    labelId="metrics-days-back"
                    label="Days Back"
                    value={daysBack}
                    onChange={(e) => setDaysBack(e.target.value)}
                    sx={{
                        minWidth: '200px',
                        marginBottom: 2,
                        borderRadius: '8px'
                    }}
                >
                    <MenuItem value={1}>
                        Yesterday
                    </MenuItem>
                    <MenuItem value={7}>
                        7 Days
                    </MenuItem>
                    <MenuItem value={14}>
                        14 Days
                    </MenuItem>
                    <MenuItem value={30}>
                        30 Days
                    </MenuItem>
                </Select>
            </FormControl>
            <Grid container spacing={1} sx={{
                width: '100%',
                height: '100%',
                minWidth: '100%'
            }} columns={{ xs: 3, sm: 6, md: 6, lg: 9, xl: 12 }}>
                {metric_list.map((metric, index) => {
                    const MetricComponent = metric.component;
                    return (
                        <Grid key={index} size={3}>
                            <MetricContainer borderColor={borderColor}>
                                <MetricComponent selectedLocations={selectedLocations} days_back={daysBack} />
                            </MetricContainer>
                        </Grid>
                    )
                })
                }
            </Grid>
        </Box>
    )
}